import BaseClass from "../BaseClass";

export default class AjaxSearch extends BaseClass {

    constructor(element) {

        super(element);

        this.submitListener = null;
        this.focusListener = null;
        this.focusOutListener = null;
        this.changeListener = null;
        this.resetListener = null;

        this.searchUrl = null;
        this.resetUrl = null;
        this.searchObject = null;

        this.$searchInput = null;
        this.$replaceElement = null;
        this.$resetSearch = null;

        this.init();

    }

    init() {

        let mySelf = this;

        this.searchUrl = this.$element.data('search-url');
        this.searchObject = this.$element.data('search-object');
        this.$resetSearch = this.$element.find();

        const $searchInput = this.$element.find('input[data-type=search-input]');
        if ($searchInput != undefined) {
            this.$searchInput = $searchInput;
        }

        const resultPlaceholder = this.$element.data('replaceelement');
        if (resultPlaceholder != undefined) {
            this.$replaceElement = $('#' + resultPlaceholder);
        }

        const $resetSearch = this.$element.find('button[data-type=search-reset]');
        if ($resetSearch != undefined) {
            this.$resetSearch = $resetSearch;
            this.resetUrl = $resetSearch.data('reset-url');
        }

        this.submitListener = function (event) {
            mySelf.onSubmit(event);
        }

        this.focusListener = function () {
            mySelf.$replaceElement.show();
        }
        this.focusOutListener = function () {
            mySelf.$replaceElement.hide();
        }
        this.changeListener = debounce(function (event) {
            mySelf.performSearch(event);
        }, 500);

        this.resetListener = function () {
            event.preventDefault();
            $(this).closest('.input-group').find('input').val('');
            mySelf.resetSearch();
        }

        this.initListener();
    }

    onSubmit(event) {
        event.preventDefault();

        let searchUrl = this.$element.data('action-url');
        const searchTerm = this.$searchInput.val();
        if (searchTerm.length >= 2) {
            searchUrl += '/' + encodeURIComponent(searchTerm.toLowerCase());
            this.redirectUser(searchUrl);
        }
    }

    performSearch() {
        let mySelf = this;

        const searchTerm = this.$searchInput.val();

        if (searchTerm.length == 0) {
            mySelf.resetSearch();
        }

        if (searchTerm.length >= 3) {
            let postData = new URLSearchParams();
            postData.append('search_object', this.searchObject);
            postData.append('search_term', searchTerm.toLowerCase());
            mySelf.doAjax(this.searchUrl, postData);
        }
    }

    resetSearch() {
        let postData = new URLSearchParams();
        postData.append('search_reset', '1');
        this.doAjax(this.resetUrl, postData);
    }


    doAjax(url, postData) {

        let mySelf = this;

        let jqxhr = $.post(url, postData.toString(), function () {
        }, 'json')
            .done(function (data) {
                mySelf.handleAjaxResponse(data);
            })
            .fail(function (data) {
                if (data.responseJSON != undefined) {

                    if (data.responseJSON.errors != undefined) {
                        mySelf.addErrors(data.responseJSON.errors);
                    } else {
                        if (jqxhr.status == 419) {
                            window.location.reload();
                        }
                    }
                }
            });
    }

    initListener() {
        this.$element.on('submit', this.submitListener);

        if (this.$searchInput != null) {
            this.$searchInput.on('focus', this.focusListener);
            this.$searchInput.on('focusout', this.focusOutListener);
            this.$searchInput.on('keyup paste', this.changeListener);
        }
        if (this.$resetSearch != null) {
            this.$resetSearch.on('click', this.resetListener);
        }

    }

    destroyListener() {
        if (this.submitListener != null) {
            this.$element.off('submit', this.submitListener);
        }
        if (this.focusListener != null) {
            this.$searchInput.off('focus', this.focusListener);
        }
        if (this.focusOutListener != null) {
            this.$searchInput.off('focusout', this.focusOutListener);
        }
        if (this.changeListener != null) {
            this.$searchInput.on('keyup paste', this.changeListener);
        }
        if (this.resetListener != null) {
            this.$resetSearch.off('click', this.resetListener);
        }
    }
}